import { render } from "./Background.vue?vue&type=template&id=031e61ec&scoped=true"
import script from "./Background.vue?vue&type=script&lang=js"
export * from "./Background.vue?vue&type=script&lang=js"

import "./Background.vue?vue&type=style&index=0&id=031e61ec&scoped=true&lang=scss"
import "./Background.vue?vue&type=style&index=1&id=031e61ec&lang=scss"

import exportComponent from "/builds/arena/frontend/game-maplestory-landing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031e61ec"]])

export default __exports__